
















import Vue from 'vue';
import { SdsButtonIcon } from '@superbet-group/web.lib.ui-components';
import { ALL_ID } from '@store/modules/ui/sportOffer/constants';
import { useI18n } from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
    getCurrentInstance,
    PropType,
} from '@vue/composition-api';
import { PredefinedItems } from '@store/modules/ui/sportOffer/sports/enums';
import { sportSwitcherTree } from '@store/modules/ui/sportOffer/sports/rawFunctions';
import OfferEvent from '@core/models/offer/OfferEvent';
import { slugify } from '@src/app/utils/slugify';
import { createSportsClickAnalyticsPayload } from '@src/app/utils/sportsClickAnalytics';
import { ClickEventType } from '@src/app/utils/clickAnalytics';
import {
    getParamWithPrefix,
    ParamTypes,
    Prefix,
} from '@src/app/utils/analyticsScreenNames';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { ClickName } from '@superbet-group/product.analytics';

const SPORT_SWITCHER_ITEM_LIMIT = 6;

export default defineComponent({
    name: 'InPlaySportSwitcher',
    props: {
        selectedSportId: {
            type: Number,
            required: true,
        },
        events: {
            type: Array as PropType<OfferEvent[]>,
            required: true,
        },
    },
    emits: ['setSelectedSport'],
    setup(props, { emit }) {
        const rootState = getCurrentInstance()?.proxy.$store.state;

        const { translate } = useI18n();

        const tree = computed(() => sportSwitcherTree(rootState, props.events));

        const sports = computed(() => {
            const sportNodes = tree.value.slice(0, SPORT_SWITCHER_ITEM_LIMIT);

            sportNodes.unshift({
                id: ALL_ID,
                name: translate(PredefinedItems.all).toString(),
                urlName: 'All',
                icon: 'actions-sort-alphabet',
            });

            return sportNodes;
        });

        const handleClick = (sport: Record<string, any>) => {
            const slug = slugify(sport.urlName);

            emit('setSelectedSport', sport.id, slug);

            const sportsClick = {
                sportCode: {
                    value: sport.id === ALL_ID ? 'all' : getParamWithPrefix(Prefix.AXILIS, ParamTypes.SPORT, sport.id)!,
                },
            };
            // @TODO(corneliu-iancu): Temporary dual analytics implementation.
            // We are currently in the process of migrating from $superAnalytics to AnalyticsSDK.
            // Both libraries are being used in parallel to validate data consistency between them.
            // DO NOT modify or remove calls to $superAnalytics until the migration is fully validated and approved.
            // Once validation is complete, $superAnalytics will be deprecated and removed.
            AnalyticsSDK.getInstance().log('click', {
                click_name: ClickName.HOMEPAGE_SPORT_SWITCHER_CLICK,
                click: {
                    sport_code: sport.id === ALL_ID ? 'all' : getParamWithPrefix(Prefix.AXILIS, ParamTypes.SPORT, sport.id)!,
                    type: 'sports_click',
                },
            });
            Vue.prototype.$superAnalytics.sendEvent(createSportsClickAnalyticsPayload(ClickEventType.homepageSportSwitcherClick, sportsClick));
        };

        return {
            sports,
            handleClick,
        };
    },
    components: {
        SdsButtonIcon,
    },
});
